import o from "./internal/_curry2.mjs";
import u from "./internal/_isInteger.mjs";
import f from "./nth.mjs";
var h = /* @__PURE__ */ o(function(e, i) {
  return e.map(function(a) {
    for (var r = i, n = 0, t; n < a.length; ) {
      if (r == null)
        return;
      t = a[n], r = u(t) ? f(t, r) : r[t], n += 1;
    }
    return r;
  });
});
export {
  h as default
};
